export const enableNpaw = (): boolean => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("enableNpaw") === "1") {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};
